const patterMap = {
  email: /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/,
  mobile: /^((1[3-9]{1}[0-9]{1})+\d{8})$/
}

class ValidatorFactory {
  email () {
    return (rule, value, callBack) => {
      if (!patterMap.email.test(value)) {
        callBack(new Error('邮箱格式不正确'))
      }
      callBack()
    }
  }

  mobile () {
    return (rule, value, callBack) => {
      if (!patterMap.mobile.test(value)) {
        callBack(new Error('请输入正确的手机号'))
      }
      callBack()
    }
  }
}

const vInstance = new ValidatorFactory()
export default vInstance
